import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    supportcategoryList: [],
    supportcategory: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
    },
    supportTypeOptions: [
      { value: 1, text: 'Warranty/FAQ/RMA' },
      { value: 2, text: 'Resources' },
      { value: 3, text: 'Marketing Tools' },
      { value: 4, text: 'Digital Marketing Materials' },
    ],
  },
  mutations: {
    CLEAR_ALL(state) {
      state.supportcategoryList = [];
      state.supportcategory = null;
    },
    SET_SUPPORTCATEGORYLIST(state, data) {
      state.supportcategoryList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SUPPORTCATEGORY(state, data) {
      state.supportcategory = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setSupportCategory({ commit }, data) {
      commit('SET_SUPPORTCATEGORY', data);
    },

    find({ commit, state }) {
      let url = `/support-category?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('supportcategory'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SUPPORTCATEGORYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/support-category/${id}`)
        .then((response) => response.body)
        .then(typeAs('supportcategory'))
        .then((item) => {
          commit('SET_SUPPORTCATEGORY', item);
        });
    },

    destroy(_, id) {
      return http(`/support-category/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/support-category/${id}`, { method: 'PUT', data })
        : http('/support-category', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/support-category/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
